import ProviderWalletTable from "./components/ProviderTable";
const ProviderWallet = () => {
    return (
        <>
        <ProviderWalletTable/>
        </>
    )
}
export default ProviderWallet;